
<template>
  <el-form-item :label="params.label">
    <el-input size="small" :class="params.className" v-model="value" :placeholder="params.placeholder" v-if="!params.numinput" :disabled="params.disabled"></el-input>
    <template v-else>
      <el-input-number size="small" v-model="value" :class="params.className"   :placeholder="params.placeholder" controls-position="right"  :min="0" ></el-input-number>
      <span class='time' v-if="params.key=='time'">分钟</span>
      <span class='time' v-if="params.key=='clearDay'||params.key=='getDay'">天</span>
    </template>
  </el-form-item>
</template>

<script>
export default {
  name: 'v-input',
  props: {
    params: {
      type: Object
    },
    rowData: {
      type: Object
    }
  },
  data() {
    return {
      value: this.rowData ? this.rowData[this.params.key] : this.params.value
    }
  },
  created() {
  },
  methods: {
    reset() {
      if (this.params.dValue) {
        this.value = this.params.dValue
      } else {
        this.value = undefined
      }
    },
    getValue() {
      if (this.value) {
        return {
          [this.params.key]: this.value
        }
      }
      return undefined
    }
  },
  watch: {
    rowData(newval) {
      this.value = newval ? this.rowData[this.params.key] : this.params.value
    },
    value(nv, ov) {
      const cp = JSON.parse(JSON.stringify(this.params))
      cp.value = nv
      this.$emit('csi', cp)
    }
  }
}
</script>

<style lang="less" scoped>
.time{
  margin: 0 10px;
}
</style>

